module.exports = __webpack_public_path__ + "img/icon-letter-x.6f56c883.svg";